import { domainid } from 'utils/utils'
import axios from 'utils/aioxs'
import Jons from 'utils/dataset.json'
export const standard_model = params => {
  return axios({
    method: 'get',
    url: `/thing_model/standard_model/list/${domainid()}`,
    params,
  })
}
export const product_thing_model = params => {
  return axios({
    method: 'get',
    url: `/thing_model/product_thing_model/list/${domainid()}`,
    params,
  })
}
export const gettypelist = params => {
  //获取产品物模型类型
  return axios({
    method: 'get',
    url: `/system_config/field/list/${domainid()}`,
    params,
  })
}
export const createModel = data => {
  //新增产品物模型
  return axios({
    method: 'post',
    url: `/thing_model/product_thing_model/create`,
    data: {
      domain_id: domainid(),
      ...data,
    },
  })
}
export const updateModel = data => {
  //新增产品物模型
  return axios({
    method: 'post',
    url: `/thing_model/product_thing_model/update`,
    data,
  })
}
export const model_define = () => {
  //model_define数据接口
  return axios({
    method: 'get',
    url: `/model_define/get`,
    params: {
      showLoding: true,
    },
  })
}
export const field_list = params => {
  //获取物模型模块-产品类别字典
  return axios({
    method: 'get',
    url: `/system_config/field/list/${domainid()}`,
    params,
  })
}
export const channelList = params => {
  //channel下拉
  return axios({
    method: 'get',
    url: `/thing_model/product_thing_model/channel_list`,
    params,
  })
}
export const publish = data => {
  //发布产品物模型
  return axios({
    method: 'post',
    url: `/thing_model/product_thing_model/publish`,
    data,
  })
}

//删除产品物模型
export const delectModel = params => {
  return axios({
    method: 'get',
    url: `/thing_model/product_thing_model/delete`,
    params,
  })
}

// 获取产品物模型列表
export function getProductModelListApi(data) {
  let params = {
    application: 'config',
    datasource: 'config_service',
    name: 'iotproduct',
    param: {
      page_size: 1000,
      ...data,
    },
    query: Jons.config.config_service.iotproduct,
  }
  return axios({
    url: '/datapool/mysql?format=row',
    method: 'post',
    data: params,
  })
}

// 新建-create/删除-delete/更新-update/发布-publish/回滚-rollback 物模型
export const setProductModelApi = (data, action) => {
  return axios({
    method: 'post',
    url: `/thing_model/modeldraft/${action}`,
    data,
  })
}

// 根据product_key 获取 productDbSchema
export const getProductDbSchema = product_key => {
  return axios({
    method: 'get',
    url: `/thing_model/${product_key}/db_schema_inner?__reset_cache__`,
  })
}

// 传入productDbSchema更新表
export const updateLindormTable = data => {
  return axios({
    method: 'post',
    url: `/tsdb/${process.env.VUE_APP_LINKU_EMS}/product_schema`,
    data,
  })
}
